import { WSList, WSPanel, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { FlowMEChangeContext } from "..";
import { queriesPersons } from "@query";
import { useSession } from "@hooks/useSession";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { getProfileDataPersonV3 } from "../../../components/FormPartialPerson/getProfileDataPersonV3";
import { FormRepresentative } from "../../../components/FormRepresentative";
import { useRequiresBankingVerification } from "../../../hooks/useRequiresBankingVerification";

import { FlowStep } from "../../../../../shared/components/FlowSwitch/types";

export const StepMaterialUpdateRepresentative: React.FC<FlowStep> = props => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();
  const requiresBanking = useRequiresBankingVerification();

  const session = useSession();
  const queryPerson = queriesPersons.getPerson.useQuery({
    personId: session.personId
  });
  const profileData = useMemo(
    () => ({
      representative: getProfileDataPersonV3({
        type: "Representative",
        person: queryPerson.data
      })
    }),
    [queryPerson.data]
  );

  const country = context.accountType?.country || "US";
  const singleOwnershipStake =
    country === "US" &&
    context.accountType?.type === "Business" &&
    context.businessInformation?.taxClassification === "LlcSingleMember";

  // These forms compute their defaults once, at mount, so the read the prefill
  // comes from has to have settled first — otherwise the fields stay empty.
  if (!queryPerson.isFetched) {
    return <WSPanel shimmer />;
  }

  return (
    <WSList gap="2XL">
      <FormRepresentative
        singleOwnershipStake={singleOwnershipStake}
        defaultValues={context.representative || profileData}
        country={country}
        onBack={props.onBack}
        onSubmit={data => {
          setContext(prev => ({
            ...prev,
            representative: data
          }));
          props.onNext?.();
        }}
        includeBeneficialOwners={requiresBanking}
        requireTaxId={requiresBanking}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
